import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Briefcase, ChevronRight } from "lucide-react";
import { useJobs } from "@/hooks/use-jobs";
import { money } from "@/lib/pipe-estimating";

interface SaveRow {
  jobId?: string | null;
  summary?: { feet?: number; welds?: number; spools?: number; estimate?: number };
}

/** Home-screen shortcut back into the job the user is working on today. */
const CurrentJobCard = () => {
  const { jobs, activeJobId } = useJobs();
  const [rollup, setRollup] = useState({ feet: 0, estimate: 0, sketches: 0 });

  useEffect(() => {
    if (!activeJobId) return;
    try {
      const raw = localStorage.getItem("tt-pipe-sketch-saves");
      const list: SaveRow[] = raw ? JSON.parse(raw) : [];
      const mine = list.filter((s) => s.jobId === activeJobId);
      setRollup({
        feet: mine.reduce((a, s) => a + (s.summary?.feet ?? 0), 0),
        estimate: mine.reduce((a, s) => a + (s.summary?.estimate ?? 0), 0),
        sketches: mine.length,
      });
    } catch {
      /* nothing saved yet */
    }
  }, [activeJobId]);

  const job = jobs.find((j) => j.id === activeJobId);
  if (!job) return null;

  return (
    <div className="px-4 mt-4">
      <Link
        to="/jobs"
        className="trade-card flex items-center gap-3 hover:border-primary/50 transition-colors"
      >
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/10">
          <Briefcase className="h-4 w-4 text-primary" />
        </span>
        <div className="min-w-0 flex-1">
          <div className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
            Current job
          </div>
          <div className="truncate text-sm font-semibold text-foreground">{job.name}</div>
          <div className="text-[11px] text-muted-foreground">
            {rollup.sketches} sketch{rollup.sketches === 1 ? "" : "es"} · {rollup.feet.toFixed(0)} ft
            {rollup.estimate > 0 ? ` · ${money(rollup.estimate)}` : ""}
          </div>
        </div>
        <ChevronRight className="h-4 w-4 shrink-0 text-muted-foreground" />
      </Link>
    </div>
  );
};

export default CurrentJobCard;
